// THE immutable Set toggle — flip a value's membership, returning a new
// Set. Extracted from the two byte-identical inline copies (ExercisePicker,
// LibraryFilters) when the second appeared in the same diff (HR-S3c).
export const toggleSetValue = <T>(set: ReadonlySet<T>, v: T): Set<T> => {
  const next = new Set(set);
  if (next.has(v)) next.delete(v);
  else next.add(v);
  return next;
};
